var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg5Clicked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_7074)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_883_7074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_883_7074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.92123 19.2262C-7.67955 19.3585 -8.336 18.6387 -8.13454 17.8958C-6.44509 11.6651 -5.25355 2.9525 -0.580971 -1.30901C4.09161 -5.57051 12.8766 -5.95683 19.2361 -7.06691C19.9944 -7.19928 20.6509 -6.47949 20.4494 -5.73652C18.76 0.494206 17.5684 9.20677 12.8958 13.4683C8.22326 17.7298 -0.561767 18.1161 -6.92123 19.2262Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0298 30.3486C38.1621 31.1069 37.4423 31.7634 36.6994 31.5619C30.4686 29.8725 21.7561 28.681 17.4945 24.0084C13.233 19.3359 12.8466 10.5509 11.7365 4.19143C11.6042 3.43311 12.324 2.77666 13.0669 2.97812C19.2977 4.66754 28.0103 5.85906 32.2718 10.5316C36.5333 15.2042 36.9197 23.9892 38.0298 30.3486Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2698 12.5556C14.762 11.5746 13.5419 11.1787 12.6588 11.8421C10.6772 13.3307 9.19105 15.408 8.43031 17.8011C7.46613 20.8341 7.7463 24.1259 9.20918 26.9523C10.6721 29.7787 13.1978 31.9083 16.2308 32.8724C18.6239 33.6332 21.178 33.6193 23.5376 32.861C24.5892 32.5231 24.9705 31.2983 24.4627 30.3174L19.8662 21.4365L15.2698 12.5556Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1723 14.4803C28.5444 14.8884 29.1804 14.9202 29.5561 14.5154C30.9357 13.0287 31.9199 11.212 32.4093 9.23256C32.9788 6.92856 32.8524 4.5074 32.0459 2.27527C31.2394 0.0431389 29.7891 -1.89972 27.8785 -3.30762C25.9678 -4.71552 23.6825 -5.52523 21.3116 -5.63435C18.9408 -5.74347 16.5908 -5.1471 14.5588 -3.92066C12.5269 -2.69422 10.9043 -0.89279 9.8962 1.25583C8.8881 3.40444 8.53978 5.80374 8.89529 8.15032C9.20073 10.1664 10.0139 12.0657 11.2511 13.6729C11.588 14.1105 12.2243 14.1373 12.6323 13.7651L20.021 7.02669C20.4291 6.65454 21.0616 6.68365 21.4338 7.09171L28.1723 14.4803Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.73026 11.3172C-4.03255 11.6027 -4.87066 12.8968 -4.43044 14.1552C-3.83199 15.866 -3.00251 17.491 -1.9622 18.9842C-0.460804 21.1392 1.45035 22.9774 3.66214 24.3937C5.87393 25.8101 8.34304 26.777 10.9285 27.2392C12.72 27.5594 14.543 27.633 16.3472 27.4609C17.6744 27.3343 18.4992 26.0317 18.2137 24.7294L14.9648 9.90942C14.6793 8.60714 13.3921 7.78286 12.0898 8.06834L-2.73026 11.3172Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#00639C",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_7074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg5Clicked);
export default __webpack_public_path__ + "static/media/profileImg5Clicked.fe2ea1c3dae3e448a443815d7ce2c302.svg";
export { ForwardRef as ReactComponent };